import * as fmt from './fmt_utils'

function bucketArray(objArray, idRetriever) {
    // input must be an array
    if ( !Array.isArray(objArray) ) {
        return undefined
    }

    return objArray.reduce((acc, obj) => {
        return {
            items: {...acc["items"], [idRetriever(obj)]: obj},
            sort: [...acc["sort"], idRetriever(obj)],
        }
    }, { items:{}, sort:[]} )
}

/**
 produces this shape:

 {
      items: {
        “tagID1”: {},
        “tagID2”: {},
      }
      sort: [“tagID1”, “tagID2”]
    }

 **/
export function bucketTags(tagArray) {
    // input must be an array
    if ( !Array.isArray(tagArray) ) {
        return undefined
    }

    const getName = (tag) => tag['name'].toLowerCase()
    const sortByName = (tags) => tags.sort((a, b) => getName(a) > getName(b))

    return bucketArray(sortByName(tagArray), tag => tag.id)
}

// collapses detail so each ownerId has a single detail with total per range
export const collapseReportDetails = (tagReportArray) => {
    const tagReportCollapsedDetails = tagReportArray.map(range => {
        const detailObj = range.detail.reduce((acc, d) => {
            return acc[d.ownerId]
                ? {
                    ...acc,
                    [d.ownerId]: {
                        ...acc[d.ownerId],
                        totalDuration:
                            acc[d.ownerId].totalDuration + d.totalDuration,
                    },
                } : { ...acc, [d.ownerId]: d }
        }, {})
        const detail = Object.values(detailObj)
        return {
            ...range,
            detail,
        }
    })
    return tagReportCollapsedDetails
}

export function bucketTagReports(tagReportArray) {
    // input must be an array
    if ( !Array.isArray(tagReportArray) ) {
        return undefined
    }

    const tagReportCollapsedDetails = collapseReportDetails(tagReportArray)
    const getId = (tagReport) => tagReport['id'].toLowerCase()
    const sortById = (tagReports) => tagReports.sort((a, b) => getId(a) > getId(b))

    return bucketArray(sortById(tagReportCollapsedDetails), tagReport => tagReport.id)
}

// returns trialEnd time as an number or null
export const parseStringToEpochTime = (trialEnd) => {
    const parsed = parseInt(trialEnd)
    // if trialEnd is a number use parsed integer, otherwise use trialEnd
    const end = Number.isInteger(parsed) ? parsed : trialEnd
    const timeEnd = new Date(end).getTime()
    // if trialEnd has a value and timeEnd is an integer use timeEnd, otherwise null
    return end && Number.isInteger(timeEnd)
        ? timeEnd
        : null
}

export function bucketTeams(teams) {
    // if teams isn't an array, make it an array
    const teamsArray = !Array.isArray(teams)
        ? [teams]
        : teams

    const teamsParsed = teamsArray.map(t => {
        return { ...t, trialEnd: parseStringToEpochTime(t.trialEndTs) }
    })

    const getName = (team) => team['name'].toLowerCase()
    const sortByName = (teams) => teams.sort((a, b) => getName(a) > getName(b))

    return bucketArray(sortByName(teamsParsed), team => team.id)
}

export function bucketUsers(usersArray) {
    // input must be an array
    if ( !Array.isArray(usersArray) ) {
        return undefined
    }

    const getName = (user) => user['primaryEmail'].toLowerCase()
    const sortByName = (users) => users.sort((a, b) => getName(a) > getName(b))

    return bucketArray(sortByName(usersArray), user => user.id)
}

/**
 produces this shape:

 {
      items: {
        “timeEntryID1”: {},
        “timeEntryID2”: {},
      }
      sort: [“timeEntryID1”, “timeEntryID2”]
    }

 **/
export function bucketTimeEntries(timeEntryArray) {
    // input must be an array
    if ( !Array.isArray(timeEntryArray) ) {
        return undefined
    }

    const convertedArray = timeEntryArray.map(fmt.convertTimeEntryToJs)
    return bucketArray(convertedArray, timeEntry => timeEntry.id)
}

export function bucketGoals(goalArray) {
    // input must be an array
    if ( !Array.isArray(goalArray) ) {
        return undefined
    }

    const getName = (goal) => goal['id'].toLowerCase()
    const sortByName = (goals) => goals.sort((a, b) => getName(a) > getName(b))

    return bucketArray(sortByName(goalArray), goal => goal.id)
}

export function ensureDateIfString(timestamp) {
    if (typeof timestamp === "string") {
        return Date.parse(timestamp)
    }
    return timestamp
}

export function convertProfileRemoteToRedux(profile) {
    const {
        accountId,
        email,
        id,
        memberships,
        name,
        personalTeamId,
        roles,
        onboardingStep,
        timezone,
        notificationPreferences,
    } = profile

    const { address, verified} = email

    return {
        id,
        memberships,
        personalTeamId,
        role: roles,
        primaryEmail: address,
        verified,
        fullName: name,
        accountID: accountId,
        onboardingStep,
        timezone,
        ...notificationPreferences,
    }
}


// WEBPACK FOOTER //
// ./src/util/redux_utils.js